module.exports = __webpack_public_path__ + "media/courses/curricula/images/level-up-blocked-57afa235da4a9942c6b83865189ac932.svg";